export const ALLOWED_MIMES =
  "image/jpeg, image/png, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, video/mp4, video/quicktime, video/3gpp";

export const IMAGE_MIMES = "image/jpeg, image/png";
